<template>
  <!-- One merge card on Otsi duplikaate (new look): the objects side by side,
       which one stays, and what happens. The same card for a group the scan
       found, a group marked "Pole duplikaat" and a manual pick, so the three
       show and count the same things; only the buttons differ (mode). -->
  <section class="obj-card obj-dup" :class="{ 'obj-dup--check': !group.sameAddress && !group.done && group.items.length > 1, 'obj-dup--manual': mode === 'manual' }">
    <div class="obj-dup__head">
      <h2 class="obj-wide">{{ group.title }}</h2>
      <span v-for="tag in group.tags" :key="tag.label" class="obj-pill obj-pill--sm" :class="tag.cls"><i />{{ tag.label }}</span>
      <span class="flex-grow-1" />
      <span class="obj-cap">{{ group.items.length }} OBJEKTI</span>
      <slot name="head" />
    </div>
    <div v-if="group.done" class="obj-dup__done">
      <v-icon size="18">mdi-check</v-icon>{{ group.done }}
      <span class="flex-grow-1" />
      <router-link v-if="group.doneId" :to="{ name: 'object/view/info', params: { objectId: group.doneId } }" class="obj-link">Ava objekt</router-link>
    </div>
    <template v-else-if="group.items.length">
      <div class="obj-dup__grid" :style="{ gridTemplateColumns: 'repeat(' + group.items.length + ', minmax(0, 1fr))' }">
        <div v-for="item in group.items" :key="item.id" class="obj-dup__cand" :class="{ 'obj-dup__cand--keep': admin && keepId === item.id }">
          <div class="d-flex align-start ga-2">
            <span class="obj-dup__addr">{{ item.parts[0] }}<mark v-if="item.parts[1]">{{ item.parts[1] }}</mark>{{ item.parts[2] }}</span>
            <span class="flex-grow-1" />
            <router-link :to="{ name: 'object/view/info', params: { objectId: item.id } }" class="obj-link">Ava</router-link>
            <button v-if="mode === 'manual'" type="button" class="obj-dup__x" aria-label="Eemalda valikust" @click="$emit('remove', item.id)">×</button>
          </div>
          <div class="d-flex flex-wrap ga-1">
            <span class="obj-pill obj-pill--sm" :class="item.type === CONTRACT ? 'obj-pill--info' : 'obj-pill--grey'">{{ item.type === CONTRACT ? 'Lepinguline' : 'Tavaline' }}</span>
            <span v-if="item.type === CONTRACT" class="obj-pill obj-pill--sm" :class="item.active ? 'obj-pill--ok' : 'obj-pill--grey'">{{ item.active ? 'Töös' : 'Väljas' }}</span>
            <span class="obj-pill obj-pill--sm obj-pill--plain">lisatud {{ day(item.createdDate) }}</span>
          </div>
          <div>
            <span class="obj-cap">KLIENT</span><br>
            <router-link v-if="item.client && item.client.id" :to="{ name: 'client/view/info', params: { clientId: item.client.id } }" class="obj-lclient">{{ item.client.fullName || '—' }}</router-link>
            <span v-else class="obj-lsub">—</span>
          </div>
          <div class="obj-dup__kv">
            <span><b>{{ item.calendarCount }}</b>töökäsku</span>
            <span><b>{{ item.noteCount }}</b>märkust</span>
            <span><b>{{ item.aktCount }}</b>akti</span>
            <span><b>{{ item.deviceCount }}</b>seadet</span>
          </div>
          <span class="obj-lsub">{{ item.lastEvent ? 'viimane töökäsk ' + day(item.lastEvent) : 'töökäske pole olnud' }}</span>
          <button v-if="admin && group.items.length > 1" type="button" role="radio" class="obj-dup__keep" :aria-checked="keepId === item.id ? 'true' : 'false'" @click="$emit('keep', item.id)">
            <span class="obj-dup__dot"><i /></span>
            {{ keepId === item.id ? (item.id === suggestedId ? 'Jääb alles (soovitus)' : 'Jääb alles') : 'Kustutatakse — vali see alles jääma' }}
          </button>
        </div>
      </div>
      <div v-if="admin" class="obj-dup__foot">
        <span class="flex-grow-1">{{ summary }}</span>
        <button v-if="mode === 'found'" type="button" class="obj-btn obj-btn--outline obj-btn--sm obj-btn--muted" :disabled="busy" @click="$emit('dismiss')">Pole duplikaat</button>
        <button v-if="mode === 'hidden'" type="button" class="obj-btn obj-btn--outline obj-btn--sm obj-btn--muted" :disabled="busy" @click="$emit('restore')">Taasta</button>
        <button type="button" class="obj-btn obj-btn--sm obj-btn--amber" :disabled="busy || group.items.length < 2" @click="$emit('merge')">
          {{ busy ? 'Ühendan…' : group.items.length > 2 ? 'Ühenda ' + group.items.length + ' → 1' : 'Ühenda' }}
        </button>
      </div>
    </template>
  </section>
</template>

<script>
import dayjs from 'dayjs'

export default {
  props: {
    // { key, title, tags, items (with parts), sameAddress, done, doneId }
    group: { type: Object, required: true },
    admin: { type: Boolean, default: false },
    keepId: { type: Number, default: null },
    suggestedId: { type: Number, default: null },
    summary: { type: String, default: '' },
    busy: { type: Boolean, default: false },
    // found: the scan's group (Pole duplikaat); hidden: marked earlier (Taasta);
    // manual: picked by hand (× per object).
    mode: { type: String, default: 'found' }
  },
  emits: ['keep', 'merge', 'dismiss', 'restore', 'remove'],
  data () {
    return { CONTRACT: 1 }
  },
  methods: {
    day (date) {
      return date && dayjs(date).isValid() ? dayjs(date).format('DD.MM.YYYY') : '—'
    }
  }
}
</script>
